const state = () => ({
  items: [],
  loading: false,
  error: null
})

const mutations = {
  setItems(state, items) {
    state.items = items || []
  },
  setLoading(state, value) {
    state.loading = !!value
  },
  setError(state, error) {
    state.error = error || null
  }
}

import { getApiUrl } from '@/config/api'

const actions = {
  async fetchReviews({ commit }) {
    commit('setLoading', true)
    commit('setError', null)
    try {
      const res = await fetch(getApiUrl('/api/reviews'))
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const data = await res.json()
      commit('setItems', data.items || [])
    } catch (e) {
      console.error('Failed to load reviews', e)
      commit('setError', e.message || 'Ошибка загрузки отзывов')
    } finally {
      commit('setLoading', false)
    }
  }
}

const getters = {
  items: (state) => state.items,
  loading: (state) => state.loading,
  error: (state) => state.error
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
